"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RevokeTokenRequest = void 0;
/**
 * Represents a revoke token request.
 * For more information look at:
 * https://tools.ietf.org/html/rfc7009#section-2.1
 */

var RevokeTokenRequest =
/** @class */
function () {
  function RevokeTokenRequest(request) {
    this.token = request.token;
    this.tokenTypeHint = request.token_type_hint;
    this.clientId = request.client_id;
    this.clientSecret = request.client_secret;
  }
  /**
   * Serializes a TokenRequest to a JavaScript object.
   */


  RevokeTokenRequest.prototype.toJson = function () {
    var json = {
      token: this.token
    };

    if (this.tokenTypeHint) {
      json['token_type_hint'] = this.tokenTypeHint;
    }

    if (this.clientId) {
      json['client_id'] = this.clientId;
    }

    if (this.clientSecret) {
      json['client_secret'] = this.clientSecret;
    }

    return json;
  };

  RevokeTokenRequest.prototype.toStringMap = function () {
    var json = this.toJson(); // :(

    return json;
  };

  return RevokeTokenRequest;
}();

exports.RevokeTokenRequest = RevokeTokenRequest;